import React from 'react';
import { FreeSpinsNotifier as FreeSpinsNotifierCore } from 'core/components';
import { withCoreComponent } from 'core/hocs';

import { FreeSpinsModal } from 'components/modals/free-spins-modal/free-spins-modal';

const FreeSpinsNotifierUI = () => <FreeSpinsModal />;

export const FreeSpinsNotifier = withCoreComponent(FreeSpinsNotifierCore, FreeSpinsNotifierUI);
